import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	heading1: {
		id: 'schools.resources.guides.heading1',
		defaultMessage: '30 Days of Mindfulness in the Classroom',
		description: 'Calm Schools guide 1 heading',
	},
	copy1: {
		id: 'schools.resources.guides.copy1',
		defaultMessage:
			'Bring mindfulness to your classrooms with ease. From breathing exercises to meditations to relaxation activities, each day is a new mindful exploration complete with a lesson plan.',
		description: 'Calm Schools guide 1 heading',
	},
	heading2: {
		id: 'schools.resources.guides.heading2',
		defaultMessage: 'Self Care Guide for Teachers',
		description: 'Calm Schools guide 2 heading',
	},
	copy2: {
		id: 'schools.resources.guides.copy2',
		defaultMessage:
			'At the heart of a mindful classroom is a healthy and happy teacher. When you’re thriving you naturally have more energy, creativity, and empathy to offer your students. It’s a win-win!',
		description: 'Calm Schools guide 2 heading',
	},
	cta: {
		id: 'schools.resources.guides.cta',
		defaultMessage: 'Download',
		description: 'Download guide button cta',
	},
});
